module.exports = __webpack_public_path__ + "static/img/pictureC.db8b142.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/pictureC.jpg
// module id = mvOX
// module chunks = 0